import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GradientButtonCourse from './../ui/GradientButtonCourse/GradientButtonCourse';
import SpeakerBadge from '../ui/SpeakerBadge/SpeakerBadge';
import './CourseCard.css';

interface CourseCardProps {
  image: string;
  date: string;
  title: string;
  description: string;
  learnMoreLink: string; 
  masters: string;
  mastersLink: string;
}

const CourseCard: React.FC<CourseCardProps> = ({
  image,
  date,
  title,
  description,
  learnMoreLink, 
  masters,
  mastersLink,
}) => {
  const { t } = useTranslation(); // ✅ Import translation function
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.3 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, []);

  return (
    <div ref={cardRef} className={`course-card ${isVisible ? 'fade-in' : ''}`}>
      <div className="course-card-image-wrapper">
        <img src={image} alt={title} className="course-card-image" />
      </div>
      <div className="course-card-content">
        <p className="course-card-date">{date} </p>
        <SpeakerBadge speakersName={masters} link={mastersLink}/>
        <h3 className="course-card-title">{title}</h3>
        <p className="course-card-description">{description}</p>

        <Link className="button-link" to={learnMoreLink}>
          <GradientButtonCourse>{t('learn_more')}</GradientButtonCourse>
        </Link>
      </div>
    </div>
  );
};

export default CourseCard;
